import { forwardRef, type ComponentProps } from 'react';
import { twMerge } from 'tailwind-merge';

const TableFooter = forwardRef<
	HTMLTableSectionElement,
	ComponentProps<'footer'>
>(({ className, ...props }, ref) => (
	<tfoot {...props} ref={ref} className={twMerge('font-medium', className)} />
));

TableFooter.displayName = 'TableFooter';

export default TableFooter;
